module.exports = __webpack_public_path__ + "static/media/third.e342132e.png";